import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { toastr } from 'react-redux-toastr';
import HudVoucherService from '../../services/hudVoucherService';
import { getHudVoucherDetailsQueryKey } from './hooks.hudVoucherQueryKeys';

const useHUDVoucherDetailsQuery = ({
  organizationId,
  propertyId,
  hudVoucherId,
  options: baseOptions,
}) => {
  const queryKey = getHudVoucherDetailsQueryKey(
    organizationId,
    propertyId,
    hudVoucherId,
  );

  const options = useMemo(() => {
    return {
      ...baseOptions,
      enabled: Boolean(organizationId && propertyId && hudVoucherId),
      refetchOnWindowFocus: false,
      retry: false,
      keepPreviousData: false,
      onError: (error) => {
        const msg =
          error?.message ||
          error?.error ||
          'Failed to load HUD voucher details. Please try again.';

        toastr.error('Error', msg);
      },
    };
  }, [baseOptions, hudVoucherId, organizationId, propertyId]);

  return useQuery(
    queryKey,
    async () => {
      const service = new HudVoucherService();
      return service.getHudVoucherById(
        organizationId,
        propertyId,
        hudVoucherId,
      );
    },
    options,
  );
};

export default useHUDVoucherDetailsQuery;
